<div class="center">
 <oaj-loader-itx [loading]="loading" [failed]="failed" #loaderSpinner></oaj-loader-itx>
</div>
<div class="modal-header">
  <h4 class="modal-title">Previsualización de Documentos</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cerrar()">
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <!--Modal Text-->
    <div class="office-viewer">
      @if(this.isImage===false){
      <iframe [src]='UrlDocto | safeUrl' width='100%' height='600vh' frameborder='0'></iframe>
      }
      @else {
      <img alt="" [src]='UrlDocto | safeUrl' />
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  @if(downloadFile && !isAcuerdoSISE){
  <button type="button" class="btn-envio" title="Descargar archivo" (click)="download()">
    <i class="fa fa-download"></i>
  </button>
  }
  @if(downloadFile && isAcuerdoSISE){
  <button type="button" class="btn-envio" title="Descargar archivo" (click)="descargarArcuerdo()">
    <i class="fa fa-download"></i>
  </button>
  }
</div>